import { themeStringToObject } from '@atlaskit/tokens';

import { DEFAULT_THEME } from './constants';

export const updateThemeWithDefaultValues = (themeString: string) => {
	const themeObject = themeStringToObject(themeString);

	// Return theme object with default values
	return {
		...DEFAULT_THEME,
		...themeObject,
	};
};
